function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.477 17.378H2.545a.88.88 0 01-.768-.392.917.917 0 01-.021-.9l2.237-4.661a.492.492 0 11.887.426l-2.179 4.54h14.62l-2.18-4.541a.492.492 0 11.887-.426l2.236 4.659a.918.918 0 01-.02.9.88.88 0 01-.767.395zm-.089-.835zm-14.755 0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.01 20.001a3.118 3.118 0 01-3.114-3.114.492.492 0 11.984 0 2.131 2.131 0 004.262 0 .492.492 0 11.984 0 3.118 3.118 0 01-3.116 3.114z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  d: "M4.438 12.141a.492.492 0 01-.492-.492V6.064a6.066 6.066 0 0112.131 0v5.575a.492.492 0 11-.984 0V6.064a5.082 5.082 0 00-10.164 0v5.585a.492.492 0 01-.491.492z"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgAlerts = function SvgAlerts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAlerts, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Alerts.3301153f.svg";
export { ForwardRef as ReactComponent };